/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  RiskScoreRevealResponse
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get risk score reveal frames for the authenticated user.

Returns a sequence of frames containing images/graphics, subtitles, and data
for displaying an animated risk score reveal experience.
 * @summary Get Risk Score Reveal
 */
export const getRiskScoreRevealV1RiskScoreRevealGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<RiskScoreRevealResponse>(
      {url: `/v1/risk-score-reveal`, method: 'GET', signal
    },
      );
    }
  

export const getGetRiskScoreRevealV1RiskScoreRevealGetQueryKey = () => {
    return [`/v1/risk-score-reveal`] as const;
    }

    
export const getGetRiskScoreRevealV1RiskScoreRevealGetQueryOptions = <TData = Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRiskScoreRevealV1RiskScoreRevealGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>> = ({ signal }) => getRiskScoreRevealV1RiskScoreRevealGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRiskScoreRevealV1RiskScoreRevealGetQueryResult = NonNullable<Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>>
export type GetRiskScoreRevealV1RiskScoreRevealGetQueryError = unknown


export function useGetRiskScoreRevealV1RiskScoreRevealGet<TData = Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>,
          TError,
          Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRiskScoreRevealV1RiskScoreRevealGet<TData = Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>,
          TError,
          Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRiskScoreRevealV1RiskScoreRevealGet<TData = Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Risk Score Reveal
 */

export function useGetRiskScoreRevealV1RiskScoreRevealGet<TData = Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoreRevealV1RiskScoreRevealGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRiskScoreRevealV1RiskScoreRevealGetQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



